import { gql } from 'graphql-tag'

export const createFeelingMeter = gql`
  mutation CreateFeelingMeter($userId: ID!, $data: CreateFeelingMeterInputType!, $stationId: ID!) {
    createFeelingMeter(userId: $userId, data: $data, stationId: $stationId) {
      id
      date
      feeling
      note
      hasFeedback
      shift
    }
  }
`

export const fetchEmployeesList = gql`
  query FetchEmployeeList($stationId: ID!) {
    employees(stationId: $stationId) {
      edges {
        node {
          id
          user {
            id
            name
          }
        }
      }
    }
  }
`
